import { UploadDocsApprovalListModel } from './../../../../models/onBoardingModels';
import { BaseComponent } from './../../../../core/abstracts/baseComponent';
import { BenefitsState } from './../../../../core/store/benefits/benefits.reducer';
import { BenefitPlanModel } from './../../../../models/benefitsModels';
import { PagingResultsModel } from '../../../../models/pagingResultsModel';
import { Component, OnInit, signal, computed } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../../../../core/store';
import { Actions, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { MultiSelect } from 'primeng/multiselect';
import { AlertService } from '../../../../shared/services/alert.service';
import { deepClone, downloadFile, getTimeStampString } from '../../../../helpers/utils';
import { ConfirmationService } from 'primeng/api';
import { tap } from 'rxjs';
import { loadUploadDocsApprovalList } from 'src/app/core/store/onboarding/onboarding.actions';
import { getFormApprovalCount, getHrEmployeeChangeCount } from '../../../../core/store/queues/queues.action';

@Component({
    selector: 'app-list-uploaddocs-approval-employees',
    templateUrl: './list-uploaddocs-approval-employees.component.html',
    styleUrls: ['./list-uploaddocs-approval-employees.component.scss'],
    standalone: false
})
export class ListUploaddocsApprovalEmployeesComponent extends BaseComponent implements OnInit {

  uploadDocsApprovalList: UploadDocsApprovalListModel[];
  canEdit: boolean;
  loadingUploadDocsApprovalList = false;
  formApprovalCount: number = 0;
  hrEmployeeChangeCount: number = 0;

  filter: any;
  yesNoAllOptions = [
    { label: 'All', value: null },
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];
  datesOptions = [
    { label: 'This Year', value: 1 },
    { label: 'Last Year', value: 2 },
    { label: 'Next Year', value: 3 },
    { label: 'Custom', value: 0 },
  ];

  totalRecords = signal<number>(0);
  dropdownOptions = computed(() => {
    var total = this.totalRecords();
    return [
      { label: '20', value: 20 },
      { label: '50', value: 50 },
      { label: '100', value: 100 },
      { label: '200', value: 200 },
      { label: '500', value: 500 },
      { label: 'All', value: total > 0 ? total : 20 } 
    ];
  });

  constructor(
    private actions$: Actions,
    private alertService: AlertService,
    private store: Store<State>,
    private router: Router,
    private confirmationService: ConfirmationService,
  ) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store.select(s => s.accountState.user?.permissionIDs).subscribe(permissionIDs => {
        this.canEdit = permissionIDs && !!permissionIDs.find(p => p === 6100);
      }),
      this.store.select(s => s.onboardingState.uploadDocsApprovalList).subscribe(uploadDocsApprovalList => {
        if (uploadDocsApprovalList) {
          this.uploadDocsApprovalList = uploadDocsApprovalList;
          this.totalRecords.set(uploadDocsApprovalList.length);
        }
      }),

      this.store.select(s => s.onboardingState.loadingUploadDocsApprovalList).subscribe(loadingUploadDocsApprovalList => {
        this.loadingUploadDocsApprovalList = loadingUploadDocsApprovalList;
      }),
      this.store.select(s => s.queuesState.formApprovalCount).subscribe(count => {
        this.formApprovalCount = count;
      }),
      this.store.select(s => s.queuesState.hrEmployeeChangeCount).subscribe(count => {
        this.hrEmployeeChangeCount = count;
      }),
    );
    this.loadPage({});
  }


  loadPage(event) {
    if (!this.loadingUploadDocsApprovalList) {
      this.loadingUploadDocsApprovalList = true;
      this.filter = deepClone(event);

      this.store.dispatch(loadUploadDocsApprovalList());
    }
    this.store.dispatch(getFormApprovalCount());
    this.store.dispatch(getHrEmployeeChangeCount());
  }


  changedFilters() {
    this.loadPage(this.filter);
  }

  openDocsToApprove(userToApprove: UploadDocsApprovalListModel) {
    this.router.navigate(['/uploaddocs/approval/' + userToApprove.userID]);
  }


}

